import { createAction } from '@reduxjs/toolkit';
export const START_TOKEN_REFRESH_TIMER = 'START_TOKEN_REFRESH_TIMER';
export const startTokenRefreshTimerAction = createAction(START_TOKEN_REFRESH_TIMER);